import { FunnelState } from "@store/funnel/interfaces/funnelState";

export const initialState: FunnelState = {
    ecommerceItem: {
        item_id: 0,
        item_name: '',
        affiliation: '',
        coupon: '',
        currency: 'EUR',
        discount: 0,
        index: 0,
        item_brand: '',
        item_category: '',
        item_category2: '',
        item_category3: '',
        item_category4: '',
        item_category5: '',
        item_list_id: '',
        item_list_name: '',
        item_variant: '',
        location_id: '',
        price: 0,
        quantity: 0
    },
    gtmData: {
        page_attributes: {
            page_type: '',
            rt_product: '',
            continent: '',
            country: '',
            region: '',
            commission_model: '',
            external_ID: 0,
            affiliation: ''
        },
        filter_attributes: {
            travel_type: '',
            travel_feature: '',
            travel_theme: '',
            places_sights: '',
            tour_operator: '',
            travel_number: 0,
            trip_duration: 0
        }
    },
    checkoutFunnel: {
        fare: null,
        flights: null,
        rooms: null,
        hotelUpgrades: null,
        services: null,
        carRentals: null,
        carExtras: null
    }
};
